var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbubbleSharpPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.2,206.5c-10.3-48.7-37.8-92.9-77.2-124.7C357.7,49.5,307.5,32,255.8,32C194.9,32,138,55.5,95.5,98.1 C54.3,139.3,31.8,193.8,32,251.4c0,42.2,12.4,83.5,35.7,118.8l4.3,6L48,480l114.8-28.6c0,0,2.3,0.8,4,1.4 c1.7,0.7,16.3,6.3,31.9,10.6c12.9,3.6,39.7,9,60.8,9c59.7,0,115.4-23.1,156.8-65.1c41.1-41.6,63.8-97,63.8-155.9 C480,236.4,478.4,221.3,475.2,206.5z M342.3,264H272v70.3c0,8.8-7.2,16-16,16s-16-7.2-16-16V264h-70.3c-8.8,0-16-7.2-16-16 s7.2-16,16-16H240v-70.3c0-8.8,7.2-16,16-16s16,7.2,16,16V232h70.3c8.8,0,16,7.2,16,16S351.2,264,342.3,264z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbubbleSharpPlus);
export default __webpack_public_path__ + "static/media/chatbubble-sharp-plus.0434f9d9fe727e91809ff9daf1e08ecb.svg";
export { ForwardRef as ReactComponent };